import { FormattedMessage } from 'react-intl';

export const resolveTransactionErrorCode = (code) => {
  const codes = {
    'ITEM_NOT_FOUND': 'base.itemNoteFound',
    'NOT_OPENED': 'transaction.notOpened',
    'TEMPLATE_NOT_OPENED': 'template.notOpened',
    'SERIES_NOT_SET': 'transaction.seriesNotSet',
    'DEFAULT': 'error.unknownError',
  }

  return <FormattedMessage id={codes?.[code] || codes['DEFAULT']} />
}
